import slugify from 'slugify';

// https://www.npmjs.com/package/slugify

export default function slugifyTextToId(text) {
  const slugifiedId = slugify(text, { lower: true, remove: /[*+~()'".?!:@]/g });
  return slugifiedId;
}
